import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { UserProgress } from '../components/UserProgress';
import { DynamicCategories } from '../components/DynamicCategories';
import { RecommendedCoupons } from '../components/RecommendedCoupons';
import { BonusOffers } from '../components/BonusOffers';
import { StackedCouponCards } from '../components/StackedCouponCards';
import { FloatingCTA } from '../components/FloatingCTA';
interface HomePageProps {
  onCouponClick: (coupon: any) => void;
  onSaveCoupon: (coupon: any) => void;
  savedCoupons: any[];
  searchQuery: string;
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}
export function HomePage({
  onCouponClick,
  onSaveCoupon,
  savedCoupons,
  searchQuery,
  activeCategory,
  onCategoryChange
}: HomePageProps) {
  // Use the provided activeCategory or default to 'groceries'
  const category = activeCategory === 'all' ? 'groceries' : activeCategory;
  return <motion.main className="flex-grow container mx-auto px-4 md:px-6 py-4 max-w-6xl pb-20 md:pb-4" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 0.3
  }} data-id="element-481">
      <motion.div initial={{
      y: 20,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.1
    }} data-id="element-482">
        <UserProgress data-id="element-483" />
        <BonusOffers data-id="element-484" />
        <RecommendedCoupons data-id="element-485" />
        <DynamicCategories activeCategory={category} onCategoryChange={onCategoryChange} data-id="element-486" />
        <div className="mb-8" data-id="element-487">
          <div className="flex justify-between items-center mb-4" data-id="element-488">
            <h2 className="text-xl font-bold" data-id="element-489">
              Browse {category.charAt(0).toUpperCase() + category.slice(1)}{' '}
              Deals
            </h2>
          </div>
          <StackedCouponCards onCouponClick={onCouponClick} onSaveCoupon={onSaveCoupon} savedCoupons={savedCoupons} category={category} data-id="element-490" />
        </div>
        <FloatingCTA data-id="element-491" />
      </motion.div>
    </motion.main>;
}